import React from 'react';
import { Card, CardContent } from '../ui/card';
import {
  Users,
  UserPlus,
  FolderKanban,
  Gift,
  TrendingUp,
  HardHat,
} from 'lucide-react';

export default function AdminStatsCards({ stats }) {
  if (!stats) return null;

  const cards = [
    { icon: Users, color: 'text-blue-400', value: stats.totals.users, label: 'Total Users' },
    { icon: HardHat, color: 'text-orange-400', value: stats.totals.team_members, label: 'Team Members' },
    { icon: UserPlus, color: 'text-green-400', value: stats.totals.leads, label: 'Total Leads' },
    { icon: FolderKanban, color: 'text-purple-400', value: stats.totals.projects, label: 'Projects' },
    { icon: Gift, color: 'text-pink-400', value: stats.free_grants, label: 'Free Grants' },
    { icon: TrendingUp, color: 'text-cyan-400', value: stats.recent_signups_7d, label: 'New (7 days)' },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4">
      {cards.map((card, index) => {
        const Icon = card.icon;
        return (
          <Card key={index} className="rounded-sm bg-slate-800 border-slate-700">
            <CardContent className="p-4">
              <div className="flex items-center gap-3">
                <Icon className={`h-8 w-8 ${card.color}`} />
                <div>
                  <p className="text-2xl font-bold">{card.value}</p>
                  <p className="text-xs text-slate-400">{card.label}</p>
                </div>
              </div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
}
